var map = {
	"./Group 22302.png": 1354,
	"./avatar-christmas.webp": 1355,
	"./bottom-bg-christmas.webp": 1356,
	"./btn-active.png": 1357,
	"./content-deco-1.webp": 1358,
	"./content-deco-2.webp": 1359,
	"./content-deco-3.webp": 1360,
	"./content-deco-4.webp": 1361,
	"./deco-3.webp": 1362,
	"./deposit-icon.webp": 1363,
	"./home-icon-active.webp": 1364,
	"./home-icon.webp": 1365,
	"./live-icon-active.webp": 1366,
	"./live-icon.webp": 1367,
	"./master-bg.jpg": 1368,
	"./master-bg.webp": 1369,
	"./me-icon-active.webp": 1370,
	"./me-icon.webp": 1371,
	"./platform.png": 1372,
	"./platform.webp": 1373,
	"./promos-icon-active.webp": 1374,
	"./promos-icon.webp": 1375,
	"./promos.webp": 1376,
	"./service-christmas.webp": 1377,
	"./snowman.webp": 1378,
	"./sponsor-icon-active.webp": 1379,
	"./sponsor-icon.webp": 1380,
	"./title-deco-left.webp": 1381,
	"./title-deco-right.webp": 1382,
	"./tree.webp": 1383,
	"./vip-icon.webp": 1384,
	"./vip.webp": 1385,
	"./withdraw-icon.webp": 1386,
	"./wwr-img.webp": 1387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;